var _style, _g, _path, _polygon, _path2, _path3, _g2, _path4, _g3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _line, _path27, _g4, _line2, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _g5, _g6, _g7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorPageBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#98C4F9;}\n\t.st2{opacity:0.25;}\n\t.st3{fill:url(#SVGID_1_);}\n\t.st4{fill:#FF6643;}\n\t.st5{fill:#092533;}\n\t.st6{fill:url(#SVGID_00000026877841035317778590000003771105066377735604_);}\n\t.st7{fill:url(#SVGID_00000127733858425944919450000008180692766631329425_);}\n\t.st8{fill:#4D5AFF;}\n\t.st9{fill:url(#SVGID_00000070114130466149163620000012275384615510985098_);}\n\t.st10{opacity:0.25;fill:none;stroke:#FFFFFF;stroke-width:0.4597;stroke-miterlimit:10;}\n\t.st11{fill:#6C5BE8;}\n\t.st12{fill:#FF9280;}\n\t.st13{fill:#350909;}\n\t.st14{fill:url(#SVGID_00000080904034410128468390000007126621638854106558_);}\n\t.st15{fill:url(#SVGID_00000123420361634560736970000009321499821271178407_);}\n\t.st16{fill:#12006D;}\n\t.st17{fill:url(#SVGID_00000098189924806055922520000011249227285892377236_);}\n\t.st18{fill:none;stroke:#092533;stroke-width:0.9195;stroke-miterlimit:10;}\n\t.st19{fill:url(#SVGID_00000163758910454253804020000016080115515439732925_);}\n\t.st20{fill:url(#SVGID_00000031910423342983898260000008468010393416715703_);}\n\t.st21{fill:url(#SVGID_00000062160534486649243620000008930029518367410597_);}\n\t.st22{fill:url(#SVGID_00000072249009574226495170000004866876224790360492_);}\n\t.st23{fill:url(#SVGID_00000045579289506227772350000007632251635930533256_);}\n\t.st24{fill:#FF7900;}\n\t.st25{fill:#C64200;}\n\t.st26{fill:url(#SVGID_00000042000824928052625610000016296853634144286090_);}\n\t.st27{fill:url(#SVGID_00000062883494083562399650000015177126367208279696_);}\n\t.st28{fill:#FFB000;}\n\t.st29{opacity:0.25;fill:none;stroke:#000000;stroke-width:0.4597;stroke-miterlimit:10;}\n\t.st30{fill:url(#SVGID_00000138568960229153363560000003789800885489730487_);}\n\t.st31{fill:url(#SVGID_00000126287974813919815200000005035753445351947420_);}\n\t.st32{fill:url(#SVGID_00000029022390018793596070000009902660710060929438_);}\n\t.st33{fill:url(#SVGID_00000100348082365691502070000001529500813520766907_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 750,
    height: 500
  }))), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M552.46,304.54l-9.19-26.97l-15.36,5.23l-31.36-92.02l-34.96,11.91l0.11,0.31l-11.28,48.68l-16.04,69.25 l9.36,20.67l33.01-11.25l12.02-4.1l13.38-4.56l10.92,32.06l34.96-11.91l-10.92-32.06L552.46,304.54z M488.89,296.1l-7.93,2.7 l-15.19,5.18l10.37-51.47l0.97-4.27l15.84,46.48L488.89,296.1z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "537.1,309.77 548.03,341.83 525.76,332.3 490.17,204.06 477.11,248.23 471.06,273.25 450.42,251.68  461.69,203 461.59,202.69 496.55,190.77 527.91,282.79 543.26,277.56 552.46,304.54  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M488.76,326.24l-12.02,4.1l1.77-24.77v-4.51l2.45-2.26l1.57-1.45l6.36-1.25 C488.89,296.1,488.49,314.29,488.76,326.24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.1719,
    y1: 268.6067,
    x2: 485.0374,
    y2: 394.4568
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7900"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M488.89,296.09c0,0-3-3.77-8.25-3.34c-5.24,0.44-8.17,2.4-8.35,7.87c-0.18,5.46,1.13,32.99-0.07,43.92 c-1.2,10.92,6.25,12.02,6.68,3.93c0.43-8.08-2.74-33.43-0.39-37.58c2.35-4.15,0.92,4.59,3.38,7.43c2.46,2.84,5.08-2.18,2.46-8.96 C481.73,302.59,488.89,296.09,488.89,296.09z"
  }))), /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M168.71,255.31c-0.9,0-1.56-0.05-1.85-0.17c-0.34-0.14-1.36-0.57-10.28-16.49l1.6-0.9 c3.33,5.95,8.38,14.6,9.46,15.71c0.97,0.16,6.31-0.22,11.04-0.69l0.18,1.83C175.88,254.9,171.32,255.31,168.71,255.31z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M201.05,263.03v0.53c0,0-0.49,10.11-8.05,9.67c-0.02,0-0.04,0-0.06,0c-4.68-0.3-10.47-2.49-14.36-4.11 c-2.44-1.02-4.13-1.82-4.32-1.79c-0.49,0.08,5.73,25.97,5.65,27.45c-0.01,0.2-0.06,0.41-0.12,0.63c-0.44,1.4-1.98,3.08-2.91,3.22 c-0.1,0.01-0.29-0.17-0.57-0.51c-2.81-3.5-13.95-23.82-14.26-30.45c-0.33-7.29,3.36-11.68,8.36-12.52 c3.69-0.62,14.47,0.87,19.87,1.69c1.92,0.29,3.15,0.5,3.15,0.5L201.05,263.03z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M179.91,294.78c-0.01,0.2-0.06,0.41-0.12,0.63c-0.44,1.4-1.98,3.08-2.91,3.22 c-0.1,0.01-0.29-0.17-0.57-0.51c3.96-5.6-6.39-32.83-4.14-32.91c1.11-0.04,3.57,1.85,6.42,3.92c-2.44-1.02-4.13-1.82-4.32-1.79 C173.77,267.41,180,293.3,179.91,294.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M201.05,263.03v0.53c0,0-0.49,10.11-8.05,9.67c1.49-1.19,1.77-3.29,1.66-5.82 c-0.13-2.94-2.85-7.97-4.37-10.58c1.92,0.29,3.15,0.5,3.15,0.5L201.05,263.03z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M184.95,229.84c-0.25,0.4-0.42,0.73-0.42,0.98c0,0-0.01-0.01-0.03-0.05c-0.09-0.16-0.4-0.7-0.81-1.34 c-0.69-1.07-1.64-2.39-2.22-2.55c-0.92-0.25-3.38,2.86-6.71,3.1c-0.22,0.02-0.44,0.02-0.67,0.01c-3.66-0.17-7.54-5.36-4.42-11.47 c1.09,2.24,3.33,2.29,3.33,2.29s-1.37-0.28-1.42-1.97c3.99,0.71,6.06-2.29,9.5-1.2c3.44,1.09,3.22,3.17,3.22,3.17 s2.62-1.04,3.44,2.24C188.41,225.68,185.96,228.27,184.95,229.84z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063615428192661707610000012075695112734838408_",
    gradientUnits: "userSpaceOnUse",
    x1: 179.1925,
    y1: 234.5525,
    x2: 180.0938,
    y2: 226.0314
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC5AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA8B6A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063615428192661707610000012075695112734838408_)"
    },
    d: "M184.5,230.77 c-0.23,0.83-0.68,1.73-1.28,2.46c-0.73,0.89-1.7,1.54-2.79,1.52c-2.33-0.06-4.64-3.18-5.67-4.76c3.32-0.25,5.78-3.36,6.71-3.1 c0.57,0.16,1.53,1.49,2.22,2.55C184.1,230.07,184.42,230.61,184.5,230.77z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108311164384008119440000013537930028291170485_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.5489,
    y1: 231.7026,
    x2: 182.6832,
    y2: 232.2761
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC5AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA8B6A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108311164384008119440000013537930028291170485_)"
    },
    d: "M187.86,231.09c0,0-1.75,3.99-2.4,3.12 c-0.35-0.47-1.37-0.79-2.24-0.97c0.6-0.73,1.05-1.63,1.28-2.46c0.02,0.03,0.03,0.05,0.03,0.05c0-0.25,0.17-0.58,0.42-0.98 C186.22,230.79,187.86,231.09,187.86,231.09z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M200.15,264.79c-2.79-0.41-10.32-8.6-10.32-12.13c0-0.5-0.06-1.05-0.15-1.65c-0.58-3.67-2.7-9.05-3.58-12.85 c-1.03-4.42,0.45-6.08,0.45-6.08c3.43-5.9,11.19,5.79,15.62,15.17l0,0c1.49,3.16,2.47,6.09,2.57,8.05 C205.06,261.95,202.94,265.2,200.15,264.79z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M200.15,264.79c-2.79-0.41-10.32-8.6-10.32-12.13c0-0.5-0.06-1.05-0.15-1.65l-0.02-1.57l2.73-14.31 c0,0,3.77,4.48,4.37,12.51c0.6,8.03,9.44,9.77,5.41-0.39c1.49,3.16,2.47,6.09,2.57,8.05 C205.06,261.95,202.94,265.2,200.15,264.79z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M194.31,247.1c-0.07,0.06-0.2,0.12-0.37,0.16c-1.29,0.36-5.06,0.3-6.62,0c-0.23-0.05-0.42-0.1-0.54-0.16 c-1.03-0.49,0-1.7-0.33-3.82c-0.33-2.13-1.14-8.36,2.02-10.27c3.31-2,5.73,5.57,5.84,9.34 C194.42,246.11,195.02,246.49,194.31,247.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074413773194785953690000018270141838873737904_",
    gradientUnits: "userSpaceOnUse",
    x1: 180.2511,
    y1: 263.8084,
    x2: 187.4613,
    y2: 237.9174
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC5AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA8B6A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000074413773194785953690000018270141838873737904_)"
    },
    d: "M193.94,247.26 c0,0-0.15,9.21-1.91,13.55c0,0,0,0,0,0.01c-0.55,1.35-1.25,2.23-2.16,2.21c-3.81-0.08-12.37-9.13-13.15-9.47 c-0.78-0.33-4.67,0.25-4.55-0.33c0.12-0.57,1.64-1.84,3.28-2.46c1.64-0.62,1.35-0.25,11.88,4.59c-0.14-0.93-0.08-4.95-0.04-7.22 c0-0.34,0.01-0.65,0.02-0.9C188.88,247.56,192.64,247.62,193.94,247.26z"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M183.05,301.01c0.27,1.64-10.76,12.86-10.18,9.92c0.57-2.95,4.01-12.29,4.01-12.29 c0.92-0.14,2.46-1.82,2.91-3.22C180.69,296.97,182.83,299.64,183.05,301.01z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M193,266.54c0,0-17.7-3.32-21.19-1.72c-3.5,1.61,6.4,29.57,6.4,29.57"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M192.03,260.81c0.34-1.85,0.59-7.22-0.34-9.35c-0.63-1.43-2.95-2.67-4.4-3.31c0-0.34,0.01-0.65,0.02-0.9 c1.57,0.31,5.33,0.36,6.62,0C193.94,247.26,193.78,256.47,192.03,260.81z"
  }))), /*#__PURE__*/React.createElement("g", null, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M478.04,198.53c-0.36,1.38-0.96,3.15-1.89,5.53c-1.32,3.41-3.32,8.05-6.27,14.52 c-0.07,3.29-1.12,24.26-1.41,29.08c-0.04,0.59-0.06,0.94-0.07,0.98c-0.04,0.21-0.8,0.62-1.63,0.82c-0.78,0.2-1.62,0.23-1.98-0.25 c-0.74-0.98-5.74-20.81-5.98-25.48c-0.25-4.67-0.49-3.6,5.24-22.2c-1.39,0.65-10.42,0.41-10.42,0.41s1.66,22.78,1.66,22.94 c0,0.02-0.01,0.08-0.05,0.16c-0.11,0.31-0.44,1.01-0.8,1.36c-0.16,0.16-0.33,0.25-0.48,0.21c-0.09-0.02-0.3-0.22-0.61-0.54 c-1.73-1.84-6.49-8.03-9.06-13.8c-3.03-6.8-3.77-11.55-0.9-16.3c2.87-4.75,17.4-5.12,17.4-5.12c0.92,0.26,3.03,0.51,5.13,1.01 c0.62,0.14,1.23,0.31,1.81,0.51c3.18,1.06,9.25,2.4,10.55,1.65C478.59,195.02,478.65,196.21,478.04,198.53z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M490.08,182.7c-0.57,0.33-7.25,0.08-11.76-1.64c0.02,0.8,0.12,2.05,0.24,3.47c0.18,2.24,0.39,4.9,0.34,6.84 c-0.03,1.38-0.19,2.4-0.57,2.64c0,0-0.01,0.01-0.02,0.01c-0.69,0.4-2.73,0.21-4.96-0.22c-1.44-0.28-2.97-0.65-4.27-1.02 c-0.47-0.14-0.92-0.28-1.32-0.41c-2.56-0.86-5.75-1.18-6.94-1.51c-0.3-0.08-0.47-0.16-0.48-0.25c-0.04-0.45,1.11-1.47,1.65-2.54 c0.06-0.13,0.15-0.33,0.25-0.58c0.44-1.12,1.12-3.23,1.45-4.58c0.2-0.8,0.27-1.32,0.1-1.23c-0.53,0.29-3.69,6.18-4.05,6.18 c-0.13,0-0.76-0.36-1.52-0.87c-1.27-0.86-2.86-2.12-2.9-2.73c-0.01-0.08,0.01-0.15,0.07-0.21c0.74-0.7,6.39-10.2,8.44-12.23 c0.96-0.96,2.1-1.53,3.02-1.87c1.03-0.39,1.82-0.47,1.82-0.47c1.22-0.04,2.45,0.12,3.64,0.42c4.06,1.02,7.79,3.58,9.92,4.85 c2.74,1.64,4.63,1.19,5.32,1.6C488.23,176.76,490.65,182.36,490.08,182.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M478.89,191.36c-3.78,0.05-12.18-0.29-16.67-3.88c0.44-1.12,1.12-3.23,1.45-4.58c0,0,8.87,2.69,14.88,1.62 C478.74,186.76,478.94,189.42,478.89,191.36z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M472.3,169.9c-0.15,1.57-0.7,3.26-2.41,3.13c-2.41-0.19-2.93-2.16-3.04-3.08c1.03-0.39,1.82-0.47,1.82-0.47 C469.87,169.43,471.1,169.59,472.3,169.9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M471.27,166.47c0,0-0.41-1.68-1.23-2.54c-0.67,1.08-3.24,1.64-5.22,1.78c-0.94,0.07-1.75,0.05-2.16-0.06 c-1.39-5.41,2.95-7.78,5.37-7.95c2.41-0.17,4.59,1.63,3.93,4.38C474.14,164.22,471.27,166.47,471.27,166.47z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003809528992224757010000004897539715227013770_",
    gradientUnits: "userSpaceOnUse",
    x1: 467.9274,
    y1: 168.8808,
    x2: 468.2551,
    y2: 161.3839
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC5AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA8B6A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003809528992224757010000004897539715227013770_)"
    },
    d: "M471.27,166.47 c-0.12,0.36-0.32,0.99-0.65,1.58h0c-0.54,0.98-1.45,1.85-3.03,1.21c-0.06-0.02-0.11-0.05-0.16-0.07c-1.33-0.6-2.02-1.77-2.37-2.7 c-0.11-0.29-0.19-0.56-0.24-0.77c1.98-0.14,4.55-0.7,5.22-1.78c0.04,0.04,0.07,0.08,0.11,0.12 C470.9,164.95,471.27,166.47,471.27,166.47z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150100636487374685160000005512875881844386993_",
    gradientUnits: "userSpaceOnUse",
    x1: 469.3832,
    y1: 172.0688,
    x2: 469.1375,
    y2: 166.7431
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC5AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA8B6A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150100636487374685160000005512875881844386993_)"
    },
    d: "M471.07,170.65 c-0.24,1.52-2.74,1.43-3.02,0.45c-0.14-0.51-0.3-1-0.43-1.36c-0.11-0.34-0.19-0.55-0.19-0.55v0c0.05,0.03,0.11,0.05,0.16,0.07 c1.58,0.64,2.49-0.23,3.03-1.21h0c-0.17,0.34,0.28,0.77,0.44,1.57C471.12,169.91,471.13,170.25,471.07,170.65z"
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M458.08,230.71c-0.24,1.88-9.99,9.26-9.83,7.95c0.16-1.31,5.13-12.59,5.13-12.59 c0.31,0.33,0.52,0.52,0.61,0.54c0.49,0.14,1.12-1.11,1.27-1.56C456.57,226.69,458.3,229.02,458.08,230.71z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M464.8,264.58c-2.29-4.92,0-15.35,0-15.35c0.74,0.98,3.52-0.17,3.6-0.57c0.01-0.05,0.03-0.4,0.07-0.98 c0,0,0.37,5,0.8,9.23C469.72,261.13,467.1,269.49,464.8,264.58z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M464.06,201.54c-1.39,0.65-10.42,0.41-10.42,0.41s1.66,22.78,1.66,22.94c0,0.02-0.01,0.08-0.05,0.16 c-0.11,0.31-0.44,1.01-0.8,1.36c-1.66-7.79-4.98-22.73-2.34-25.3c3.39-3.28,12.56-4.15,12.7-3.43 C464.96,198.39,464.06,201.54,464.06,201.54z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075145266800261875260000013543617593445146255_",
    gradientUnits: "userSpaceOnUse",
    x1: 452.9455,
    y1: 212.2699,
    x2: 458.8447,
    y2: 173.925
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC5AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA8B6A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075145266800261875260000013543617593445146255_)"
    },
    d: "M457.56,190.78 c-0.13,0.28-0.2,0.51-0.16,0.66c0.2,0.76-0.85,10.32-0.47,11.3c0.38,0.98,0.6,4.1,0.38,6.06c-0.22,1.97-4.32,3.17-4.32,1.48 c0-1.7,0.49-5.68,0.66-7.21c0.17-1.53-1.37-12.59-0.96-14.12c0.27-1,1.29-2.69,1.97-3.74c0.36-0.57,0.63-0.95,0.63-0.95 c0.06,0.96,4.08,3.6,4.42,3.6C459.72,187.85,458.1,189.67,457.56,190.78z"
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M478.04,198.53c-1.81-0.13-3.84-0.92-5.25-2.34c-1.65-1.65-4.39-3.17-6.85-4.33 c0.62,0.14,1.23,0.31,1.81,0.51c3.18,1.06,9.25,2.4,10.55,1.65C478.59,195.02,478.65,196.21,478.04,198.53z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M476.15,204.06c-1.32,3.41-3.32,8.05-6.27,14.52c-0.07,3.29-1.12,24.26-1.41,29.08 c-0.04,0.59-0.06,0.94-0.07,0.98c-0.04,0.21-0.8,0.62-1.63,0.82c0.19-7.07-0.06-22.46,1.14-27.04 C469.34,216.95,475.75,204.81,476.15,204.06z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M469.07,192.77c-0.47-0.14-0.92-0.28-1.32-0.41c-2.56-0.86-5.75-1.18-6.94-1.51 c-0.3-0.08-0.47-0.16-0.48-0.25c-0.04-0.45,1.11-1.47,1.65-2.54c0.53-1.07,2.33-6.68,1.8-6.39c-0.53,0.29-3.69,6.18-4.05,6.18 c-0.13,0-0.76-0.36-1.52-0.87c0.08-0.13,0.17-0.27,0.26-0.41c1.96-2.9,5.19-6.5,5.73-9.61c0.44-2.29,1.09-0.98,0.98,1.97 C465.08,181.57,464.94,189.68,469.07,192.77z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M478.32,194c0,0-0.01,0.01-0.02,0.01c-0.69,0.4-2.73,0.21-4.96-0.22c4-4,1.82-14.85,2.44-14.29 c0.74,0.65,2.54,1.55,2.54,1.55C478.4,184.01,479.59,193.22,478.32,194z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M459.72,187.85c0,0-1.62,1.81-2.16,2.92c-0.01-0.24-0.03-0.47-0.06-0.67c-0.12-1.17-1.95-3.72-2.84-4.9 c0.36-0.57,0.63-0.95,0.63-0.95C455.36,185.22,459.39,187.85,459.72,187.85z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M470.15,164.05c-0.98,2.17-3.88,2.43-5.09,2.43c-0.11-0.29-0.19-0.56-0.24-0.77 c1.98-0.14,4.55-0.7,5.22-1.78C470.08,163.97,470.12,164.01,470.15,164.05z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M471.06,169.62c-0.18,0.14-0.41,0.25-0.69,0.31c-1.32,0.3-2.25,0.04-2.75-0.19 c-0.11-0.34-0.19-0.55-0.19-0.55v0c0.05,0.03,0.11,0.05,0.16,0.07c1.58,0.64,2.49-0.23,3.03-1.21h0 C470.46,168.39,470.91,168.82,471.06,169.62z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st18",
    x1: 484.14,
    y1: 0,
    x2: 484.14,
    y2: 204.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085935458817026764430000005844234503445814697_",
    gradientUnits: "userSpaceOnUse",
    x1: 485.9506,
    y1: 166.02,
    x2: 490.5388,
    y2: 190.2176
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC5AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA8B6A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085935458817026764430000005844234503445814697_)"
    },
    d: "M492.74,179.77 c-0.01,0.06-0.02,0.11-0.03,0.16c-0.54,2.47-2.52,2.73-2.89,2.57c-0.37-0.16-1.36-1.29-2.22-5.28c-0.02-0.08-0.03-0.16-0.05-0.24 c0,0-1.86-4.76-2.73-7.05c-2.16-1.28-2.57-0.76-2.87-2.23c-0.3-1.48,0.66-3.38,1.2-3.66c0.55-0.27,3,2.02,3.33,2.87 C486.81,167.75,493.23,177.15,492.74,179.77z"
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M492.71,179.93c-0.54,2.47-2.52,2.73-2.89,2.57c-0.37-0.16-1.36-1.29-2.22-5.28 c0.55,1.11,1.39,2.54,2.31,3.14C490.93,181.01,492.07,180.8,492.71,179.93z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M420.32,309l-5.27-26.91c-3.9-19.9-11.42-34.42-22.55-43.56c-11.14-9.14-24.9-12.1-41.28-8.89 c-16.38,3.21-28,11.11-34.84,23.69c-6.85,12.59-8.32,28.87-4.41,48.84l5.29,27.01c3.88,19.83,11.39,34.32,22.53,43.45 c4.7,3.86,9.88,6.62,15.53,8.27c7.73,2.27,16.34,2.46,25.85,0.61c4.92-0.96,9.42-2.35,13.48-4.17 c9.4-4.21,16.49-10.71,21.27-19.5C422.76,345.25,424.23,328.97,420.32,309z M387.43,345.12c-1.8,5.52-5.61,8.85-11.43,9.99 c-6.03,1.18-10.92-0.51-14.7-5.08c-2.57-3.11-4.78-7.73-6.6-13.86c0,0,0-0.01,0-0.01c0-0.01,0-0.02-0.01-0.03 c-0.85-2.84-1.61-6.01-2.29-9.5l-7.4-37.78c-1.73-9.92-1.74-17.58-0.02-22.98c1.72-5.4,5.53-8.68,11.42-9.82 c4.49-0.88,8.37-0.12,11.62,2.27h0c1.11,0.82,2.15,1.82,3.11,3.02c3.8,4.7,6.74,12.37,8.82,23l7.16,36.55 C389.13,331.52,389.23,339.6,387.43,345.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M390.08,350.17c1.52,2.34,3.54,18.21,4.57,27.17c-4.06,1.82-8.56,3.21-13.48,4.17 c-9.5,1.86-18.12,1.66-25.85-0.61c0.32-0.71,0.61-1.46,0.86-2.22c4.82-14.73-1.2-41.32-1.48-42.52 c1.83,6.13,4.03,10.75,6.6,13.86c3.78,4.57,8.68,6.26,14.7,5.08c5.82-1.14,9.63-4.47,11.43-9.99c1.8-5.52,1.7-13.6-0.32-24.24 l-7.16-36.55c-2.08-10.62-5.02-18.29-8.82-23c-0.97-1.2-2-2.2-3.11-3.02c11.63,2.28,21.07,38.28,25.01,55.64 C396.96,331.32,397.29,339.35,390.08,350.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M357.26,343.23c0,0,0.75,1.97,4.71,3.06c3.96,1.09,7.67-5.03,10.3-3.06c2.62,1.97,6.82,10.14,10.51,8.9 c3.69-1.24,4.78,18.42,3.04,20.6c-1.75,2.18-3-15.47-7.62-14.95c-4.62,0.53-1.12,13.85-3.74,16.26c-2.62,2.4-1.53-5.9-4.37-7.43 c-2.84-1.53,3.06,66.86-1.31,67.95c-4.37,1.09-7.21-3.06-5.46-17.7c1.75-14.64-0.44-65.11-3.06-67.73 C357.63,346.51,357.79,346.02,357.26,343.23z"
  }))), /*#__PURE__*/React.createElement("g", null, _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st18",
    x1: 356.17,
    y1: 0,
    x2: 356.17,
    y2: 238.57
  })), /*#__PURE__*/React.createElement("g", null, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M412.89,146.32c0,0-3.48-9.55-3.2-10.28c0.29-0.74,4.11-2.13,4.39-1.72c0.28,0.41,2.7,7.82,2.29,8.36 C415.97,143.2,412.89,146.32,412.89,146.32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098905745536856067330000008671842335178240141_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.8157,
    y1: 130.3247,
    x2: 358.6842,
    y2: 136.4203
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC5AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA8B6A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098905745536856067330000008671842335178240141_)"
    },
    d: "M354.97,133.8c0,0,2.13,0.88,3.07,3.18 c0.94,2.29,0.58-5.98,0.58-5.98l-1.02-0.94L354.97,133.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000117671921504865618850000010457395639067175066_",
    gradientUnits: "userSpaceOnUse",
    x1: 351.4661,
    y1: 130.1741,
    x2: 358.5944,
    y2: 133.1647
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC5AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA8B6A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000117671921504865618850000010457395639067175066_)"
    },
    d: "M353.86,133.8c0,0,2.66,1.99,3.11,2.11 c0.45,0.12,1.32-5.08,0.93-5.9c-0.39-0.82-1.84-1.64-2.78-1.11C354.19,129.44,353.42,133.48,353.86,133.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165928884680410190410000012543905661792820893_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.5578,
    y1: 127.8798,
    x2: 360.1461,
    y2: 137.63
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC5AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA8B6A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165928884680410190410000012543905661792820893_)"
    },
    d: "M360.95,134.39 c0,0-2.12-4.92-3.05-5.78c-0.93-0.86-2.65,0.25-2.77,0.7c-0.12,0.45,2.06,0.78,2.77,1.52c0.71,0.74-1.21,6.19,0.63,8.11 C360.38,140.87,360.95,134.39,360.95,134.39z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072975764734731806850000014527494357398413215_",
    gradientUnits: "userSpaceOnUse",
    x1: 420.892,
    y1: 137.5286,
    x2: 407.8647,
    y2: 153.014
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC5AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA8B6A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072975764734731806850000014527494357398413215_)"
    },
    d: "M410.27,147.42 c0,0,1.88-1.02,2.29-1.56c0.41-0.53-0.33-2.54,0.86-4.38c1.19-1.84,3.73-1.31,4.34,0.9c0.61,2.21-0.98,5-1.72,5.86 c-0.74,0.86-5.78,4.47-5.78,4.47"
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M411.62,151.7c-0.06,0.33-0.39,0.89-1.04,1.65c-2.39,2.8-8.98,8.27-20.85,14.52 c-0.23,0.96-0.42,1.93-0.56,2.91c-0.44,3.11-0.43,6.26-0.29,9.08c0.04,0.73,0.08,1.43,0.13,2.11c0.22,2.98,0.51,5.44,0.43,6.86 c-0.04,0.63-0.15,1.05-0.36,1.24c-0.27,0.23-0.55,0.45-0.84,0.63c-5.93,3.81-16.73-1.88-18.47-3.59 c-0.14-0.13-0.22-0.24-0.24-0.32c-0.3-1.15,0.87-2.38,1.53-4.34c0.11-0.34,0.22-1.09,0.33-2.11c0.31-3.03,0.58-8.45,0.68-12.53 c0.06-2.6,0.04-4.66-0.08-5.2c0-0.01,0-0.02,0-0.02c-0.33-1.34-10.27-16.36-13.25-21.69c-0.55-0.97-0.86-1.62-0.84-1.8 c0.11-1.2,2.4-5.46,2.9-5.41c0.08,0.01,0.39,0.39,0.85,1.03c2.3,3.2,8.5,12.87,9.64,14.1c1.07,1.15,6.5,6.87,8.82,9.32 c0.66,0.68,1.07,1.12,1.07,1.12c1.26-0.02,2.52-0.14,3.79-0.34c11.18-1.72,22.16-9.55,25.03-11.72 c0.47-0.36,0.73-0.56,0.73-0.56S411.87,150.16,411.62,151.7z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M383.73,164.2c-3.81,0.62-3.82-4.34-3.62-6.06c0.66,0.68,1.07,1.12,1.07,1.12 c1.26-0.02,2.52-0.14,3.79-0.34C385.44,160.88,385.06,163.99,383.73,164.2z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M387.59,153.57c-0.74,0.45-1.71,0.6-2.94,0.28c-0.95-0.24-2.05-0.76-3.35-1.64c0,0-1.02,1.23-1.1,3.48 c-2.7-2.34-3.36-4.67-1.07-5.53c-0.94-4.1,1.07-4.96,4.42-5.16c3.36-0.21,4.14,3.24,6.15,3.15 C389.83,149.99,389.31,152.56,387.59,153.57z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023973558757761230380000013614036564275475120_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.4565,
    y1: 161.1322,
    x2: 383.0637,
    y2: 144.9094
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC5AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA8B6A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023973558757761230380000013614036564275475120_)"
    },
    d: "M387.59,153.57 c-0.04,0.33-0.09,0.71-0.17,1.12c-0.45,2.4-1.63,5.74-3.4,5.55c-0.09,0-0.19-0.02-0.29-0.06c-1.6-0.5-2.56-2.05-3.06-3.19 c-0.33-0.74-0.47-1.31-0.47-1.31c0.03-0.71,0.15-1.32,0.3-1.83c0.33-1.08,0.8-1.66,0.8-1.66c1.29,0.88,2.4,1.4,3.35,1.64 C385.89,154.17,386.85,154.02,387.59,153.57z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155117616804509779620000009550406622880996531_",
    gradientUnits: "userSpaceOnUse",
    x1: 382.0739,
    y1: 161.259,
    x2: 382.7294,
    y2: 157.0804
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC5AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA8B6A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155117616804509779620000009550406622880996531_)"
    },
    d: "M384.02,161.66 c-0.02,0.87-0.14,1.55-0.72,1.59c-1.17,0.08-2.73-1.45-2.65-3.11c0.03-0.57,0.04-1.17,0.04-1.72c0-0.56-0.01-1.06-0.02-1.42 c0.5,1.14,1.46,2.69,3.06,3.19c0.1,0.03,0.2,0.05,0.29,0.06C384.02,160.73,384.03,161.22,384.02,161.66z"
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M411.62,151.7c-0.06,0.33-0.39,0.89-1.04,1.65c0.03-1.95-0.4-4.92-0.58-6.14 c0.47-0.36,0.73-0.56,0.73-0.56S411.87,150.16,411.62,151.7z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M361.64,134.72c-1.75,1.49-2.6,4.75-2.9,6.18c-0.55-0.97-0.86-1.62-0.84-1.8c0.11-1.2,2.4-5.46,2.9-5.41 C360.88,133.71,361.19,134.09,361.64,134.72z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M389.02,181.97c-3.91,0.57-11.26,1.07-17.62-1.63c0.31-3.03,0.58-8.45,0.68-12.53 c3.15,1.33,9.95,3.71,17.09,2.96C388.61,174.68,388.77,178.65,389.02,181.97z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M388.25,190.7c-6.39,4.1-18.43-2.82-18.71-3.91c-0.3-1.15,0.87-2.38,1.53-4.34 c0.11-0.34,0.22-1.09,0.33-2.11c0.31-3.03,0.58-8.45,0.68-12.53c0.06-2.6,0.04-4.66-0.08-5.2c0.14,0.42,2.3,7.27,3.41,13.94 c1.15,6.88,0.9,10.16,4.26,12.37C381.64,190.21,385.23,190.89,388.25,190.7z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M402.86,209.62c0,2.84-10.27,18.58-12.4,21.81c-0.24,0.37-0.38,0.58-0.38,0.58s-1.32-0.15-2.41-0.52 c-0.76-0.26-1.41-0.62-1.41-1.12c0-0.1,0.02-0.26,0.05-0.46c0.36-2.19,2.62-10.13,5.52-20.62c-1.53-1.86-12.23-8.96-12.23-8.96 s0,0.01-0.01,0.03c-0.46,1.07-15.33,35.44-17.01,38.65c-0.06,0.12-0.1,0.19-0.13,0.22c-0.76,0.98-3.93,1.09-4.15-0.98 c0,0,0,0,0-0.01c-0.91-8.69,6.58-34.89,10.07-46.48c0.63-2.08,1.12-3.69,1.42-4.64c1.75,1.71,12.54,7.4,18.47,3.59 c0.29-0.19,0.57-0.4,0.84-0.63c0.21-0.19,0.32-0.61,0.36-1.24c0.11,0.12,0.23,0.25,0.34,0.39 C393.93,193.95,402.86,206.89,402.86,209.62z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M363.61,243.82c-0.41,2.05-11.23,8.11-10.24,4.44c0.8-2.97,3.81-8.16,4.91-10.02c0,0,0,0,0,0.01 c0.22,2.07,3.39,1.97,4.15,0.98c0.03-0.03,0.07-0.11,0.13-0.22C363.12,240.59,363.88,242.49,363.61,243.82z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M394.01,242.02c-0.82,0.41-11.47-3.69-11.23-5.08c0.25-1.39,3.52-7.02,3.52-7.02 c-0.03,0.21-0.05,0.36-0.05,0.46c0,1.2,3.82,1.64,3.82,1.64s0.14-0.21,0.38-0.58C390.93,235.69,394.78,241.63,394.01,242.02z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M378.2,199.16c0,0-11.8,23.17-16.22,39.07"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M380.98,199.16c0,0,13.11,8.6,13.6,10c0.49,1.39-6.8,20.76-6.8,20.76"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M389.79,189.22c-1.44,5.77-9.8,4.2-14.08,3.09c-2.49-0.64-5.34-0.67-7.36-0.56 c0.63-2.08,1.12-3.69,1.42-4.64c1.75,1.71,12.54,7.4,18.47,3.59c0.29-0.19,0.57-0.4,0.84-0.63c0.21-0.19,0.32-0.61,0.36-1.24 C389.56,188.95,389.68,189.08,389.79,189.22z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M387.66,231.5c-0.76-0.26-1.41-0.62-1.41-1.12c0-0.1,0.02-0.26,0.05-0.46c0.36-2.19,2.62-10.13,5.52-20.62 c-1.53-1.86-12.23-8.96-12.23-8.96s0.87-2.95,1.86-3.17c0.98-0.22,12.34,9.56,13.6,11.58 C396.15,210.53,388.42,225.04,387.66,231.5z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M387.59,153.57c-0.04,0.33-0.09,0.71-0.17,1.12c-2.86,1.46-5.67-1.83-6.01-1.78 c-0.19,0.02-0.59,0.52-0.91,0.96c0.33-1.08,0.8-1.66,0.8-1.66c1.29,0.88,2.4,1.4,3.35,1.64 C385.89,154.17,386.85,154.02,387.59,153.57z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M384.02,161.66c-1.89-0.46-2.93-2.35-3.33-3.24c0-0.56-0.01-1.06-0.02-1.42c0.5,1.14,1.46,2.69,3.06,3.19 c0.1,0.03,0.2,0.05,0.29,0.06C384.02,160.73,384.03,161.22,384.02,161.66z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M389.17,170.77c-0.44,3.11-0.43,6.26-0.29,9.08c-0.74-3.14-1.4-6.51-0.63-8.47 c1.31-3.37,1.46-3.52,1.48-3.52C389.49,168.82,389.31,169.8,389.17,170.77z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M297.18,202.12l-35.37-6.08l-0.06,0.32l-78.11,87.95l-1.61,21.98l11.2,1.93l19.39,3.33l26.03,4.47 l2.47,0.42l-1.86,10.85l-0.86,5.02l-2.85,16.57l23.02,3.96l12.35,2.12l5.57-32.43l15.54,2.67l4.69-27.29l-15.54-2.67 L297.18,202.12z M253.03,247.19l-7.21,41.97l-8.63-1.49l-18.87-3.24l10.45-12.47l2.39-2.86l19.93-23.78l2.82-3.19L253.03,247.19 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M238.66,316.02l-26.03-4.47c3.07-10.13,6.89-24.09,5.69-27.12l18.87,3.24c1.21,2.01,2.17,4.79,2.42,8.59 C240.07,302.99,239.06,309.86,238.66,316.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219.44,284.62c0,0,2.84-3.94,9.23-2.71c6.39,1.23,6.88,9.1,4.1,17.78c-2.79,8.68-3.44,39-2.13,48.83 c1.31,9.83,0.49,14.42-2.62,14.75c-3.11,0.33-4.59-11.8-2.79-20.32c1.8-8.52,1.64-16.39-1.31-15.08 c-2.95,1.31-0.49,4.59-1.97,7.54c-1.47,2.95-5.9,1.15-5.74-4.42C216.38,325.42,225.29,289.21,219.44,284.62z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "281.19,295.23 296.73,297.9 292.04,325.19 276.5,322.53 270.93,354.96 258.58,352.84  280.28,217.41 297.18,202.12  "
  })), /*#__PURE__*/React.createElement("line", {
    className: "st18",
    x1: 270.62,
    y1: 0,
    x2: 270.62,
    y2: 211.09
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M336.49,162.61c0,3.53-2.86,6.39-6.39,6.39c-3.53,0-6.39-2.86-6.39-6.39c0-3.53,2.86-6.39,6.39-6.39 C333.63,156.22,336.49,159.08,336.49,162.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M558.85,243.83c0,3.53-2.86,6.39-6.39,6.39c-3.53,0-6.39-2.86-6.39-6.39c0-3.53,2.86-6.39,6.39-6.39 C555.99,237.43,558.85,240.3,558.85,243.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.7,197.16c0,3.53-2.86,6.39-6.39,6.39s-6.39-2.86-6.39-6.39c0-3.53,2.86-6.39,6.39-6.39 S224.7,193.64,224.7,197.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M330.1,392.61c0,3.53-2.86,6.39-6.39,6.39c-3.53,0-6.39-2.86-6.39-6.39c0-3.53,2.86-6.39,6.39-6.39 C327.24,386.22,330.1,389.08,330.1,392.61z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st24",
    cx: 515.93,
    cy: 181.85,
    r: 2.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 327.64,
    cy: 220.23,
    r: 2.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M256.36,186.85c0,1.36-1.1,2.46-2.46,2.46c-1.36,0-2.46-1.1-2.46-2.46c0-1.36,1.1-2.46,2.46-2.46 C255.26,184.39,256.36,185.49,256.36,186.85z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013164017447467792940000013876451924987276720_",
    gradientUnits: "userSpaceOnUse",
    x1: 623.1288,
    y1: 71.5869,
    x2: 402.2359,
    y2: 122.7135
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#98C4F9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013164017447467792940000013876451924987276720_)"
    },
    d: "M587.37,51.76c0,0-9.85-9.83-28.52-5.9 c-18.67,3.93-31.79,33.43-45.39,39.98c-13.59,6.55-40.4,25.91-42.4,42.45c26.18-21.8,36.01-12.3,53.06-14.92 c17.04-2.62,18.35-22.61,42.93-21.96c24.58,0.66,50.8,31.2,75.38,14.12c24.58-17.07,53.42-37.39,30.15-54.11 C649.31,34.72,602.12,60.28,587.37,51.76z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042004552509835460820000014077612547521389499_",
    gradientUnits: "userSpaceOnUse",
    x1: -1378.3147,
    y1: 797.8002,
    x2: -1599.2155,
    y2: 848.9286,
    gradientTransform: "matrix(-0.5639 -0.8258 0.8258 -0.5639 -1251.3242 -610.823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#98C4F9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042004552509835460820000014077612547521389499_)"
    },
    d: "M188.52,118.22 c0,0-2.56,13.68,11.21,26.88c13.78,13.2,45.54,7.41,58.62,14.94c13.08,7.53,44.18,18.75,58.97,11.07 c-32.77-9.33-30.47-22.81-42.24-35.4c-11.78-12.6-29.02-2.4-42.34-23.07c-13.32-20.67-2.88-59.54-30.84-70.21 c-27.96-10.67-61.01-23.03-61.69,5.61C139.52,76.67,187.24,101.23,188.52,118.22z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093172366003898630150000001317613948932865200_",
    gradientUnits: "userSpaceOnUse",
    x1: 646.1055,
    y1: 295.2856,
    x2: 329.0299,
    y2: 368.6743
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#98C4F9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093172366003898630150000001317613948932865200_)"
    },
    d: "M664.39,196.64 c0,0-39.98,43.87-48.5,95.3c-8.52,51.43-49.51,48.16-63.43,72.41c-13.92,24.25-47.09,26.22-62.3,36.05 c-15.2,9.83-49.84-7.21-55.79,0c-5.95,7.21,31.07,18.35,79.09,19.01c48.02,0.66,57.2-36.71,99.8-41.95 c42.61-5.24,85.21-23.6,100.29-93.08C728.63,214.9,703.06,177.72,664.39,196.64z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109745541127971380250000017630865259354879134_",
    gradientUnits: "userSpaceOnUse",
    x1: -1693.7058,
    y1: 312.9505,
    x2: -2010.7815,
    y2: 386.3391,
    gradientTransform: "matrix(-1 0 0 1 -1588.0908 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#98C4F9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109745541127971380250000017630865259354879134_)"
    },
    d: "M87.33,214.3c0,0,39.98,43.87,48.5,95.3 c8.52,51.43,49.51,48.16,63.43,72.41c13.92,24.25,47.09,26.22,62.3,36.05c15.2,9.83,49.84-7.21,55.79,0 c5.95,7.21-31.07,18.35-79.09,19.01c-48.02,0.66-57.2-36.71-99.8-41.95c-42.61-5.24-85.21-23.6-100.29-93.08 C23.09,232.57,48.66,195.39,87.33,214.3z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "DESIGNED_BY_FREEPIK"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorPageBg);
export default __webpack_public_path__ + "static/media/error-page-bg.34958ea07f1a382b04308f3b10d3a726.svg";
export { ForwardRef as ReactComponent };